import {useMemo} from 'react';
import Link from './link';
import Header from './header';
import UptimeRobot from './uptimerobot';
import Package from '../../package.json';

function App() {

    const apikeys = useMemo(() => {
        const {ApiKeys} = window.Config;
        if (Array.isArray(ApiKeys)) return ApiKeys;
        if (typeof ApiKeys === 'string') return [ApiKeys];
        return [];
    }, []);
    const years = useMemo(() => {
        const start = 2020;
        const current = new Date().getFullYear();
        if (start === current) return start;
        return `${start} - ${current}`;
    }, []);

    return (
        <>
            <Header/>
            <div className="container">
                <div id="uptime">
                    {apikeys.map((key) => (
                        <UptimeRobot key={key} apikey={key}/>
                    ))}
                </div>
                <div id="footer">
                    <p>基于 <Link to="https://uptimerobot.com/" text="UptimeRobot"/> 接口制作，检测频率 5 分钟</p>
                    <p>&copy; {years} <Link to="https://status.org.cn/" text="STATUS.ORG.CN"/>,
                        Version {Package.version}</p>
                </div>
            </div>
        </>
    );
}

export default App;
